import {
    FETCH_LOG_LIST_REQUEST,
    FETCH_LOG_LIST_SUCCESS,
    FETCH_LOG_LIST_FALUIRE,
} from './loglistTypes'

const initialState = {
    loading: false,
    logListInfo: null,
    error: '',
}

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_LOG_LIST_REQUEST: return {
            ...state,
            loading: true,

        }

        case FETCH_LOG_LIST_SUCCESS: return {
            ...state,
            logListInfo: action.payload,
            error: '',
            loading: false,
        }

        case FETCH_LOG_LIST_FALUIRE: return {
            ...state,
            loading: false,
            logListInfo: null,
            error: action.payload,
        }
        default: return state
    }
}

export default reducer
